<h1 mat-dialog-title>{{ 'platformNotes.dialog.associateBalances.title' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="row" *ngIf="!balances || balances && !balances.length">
    <div class="col-12">
      <p class="font-italic">
        {{ 'platformNotes.dialog.associateBalances.noBalances' | translate }}
      </p>
    </div>
  </div>
  <div class="row" *ngIf="balances && balances.length">
    <div class="col-8">
      <!-- <div class="mb-3">
        <input matInput (keyup)="onFilterProperties()" placeholder="{{ 'platformNotes.dialog.associateBalances.filter' | translate }}"
          [disabled]="!balances.length" [(ngModel)]="filterProperty">
      </div> -->
      <ng-container *ngFor="let item of balances; let i = index;">
        <div class="text-wrapper" *ngIf="item.visible">
          <mat-checkbox [(ngModel)]="item.value" class="checkbox-insert" > <!-- [checked]="selectAll" -->
            {{ item.number }} - {{ item.status }}
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
    <div class="col-4">
      <!-- <div class="text-wrapper text-right" *ngIf="filterProperty ===''">
        <mat-checkbox class="checkbox-insert" (change)="onSelectAll($event.checked)"
          [disabled]="!balances || balances && !balances.length" [checked]="selectAll">
          {{ 'common.cta.selectAll' | translate }}
        </mat-checkbox>
      </div> -->
    </div>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (click)="onFormSubmit()" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->